<template>
   <form @submit.prevent>
      <div style="position:relative; display: flex; align-items: center;">
         <input @input="inputNum" ref='dateinput' id="dateinput" class="form-control" :disabled="isdisabled" style="width: 200px;" :class="isdisabled ? 'dis' : 'nodis'" v-bind:value="svalue(value)"
                @keyup.enter="keyEnter" @blur="tran($event.target.value)"><span v-if="!isdisabled && isShowLong" class="dfLongTerm" @click="setLongTerm">长期</span>
      </div>
   </form> <!-- <i class="el-icon-circle-close icon" :class="isOver ? 'icon-active' : 'icon-leave'" @click="clear" @mouseover="isOver = true" @mouseleave="isOver = false"></i> -->
   <!-- @keyup.enter="tran($event.target.value)"  -->
</template>
<script type="text/javascript">
export default {
   name: 'df-date',
   props: {
      value: {
         type: [Number, String],
         require: true,
      },
      isType: {
         type: Boolean,
         require: false,
      },
      isdisabled: {
         type: Boolean,
         require: false,
         default: false
      },
      isShowLong: {
         type: Boolean,
         require: false,
         default: true
      },
      isLongTime: {
         type: Boolean,
         require: false,
         default: false
      },
      isNull: {//判断是否验证空 true:可以为空 false:不可以为空 
         type: Boolean,
         require: false,
         default: false
      },
      isError: {//判断是否拦截提示：日期格式不对 true:不提示 false：提示
         type: Boolean,
         require: false,
         default: false
      },
   },
   data() {
      return {
         isOver: false,
         time: "",
      }
   },
   watch: {
      'isdisabled': {
         handler: function (newValue, oldValue) {
            this.isdisabled = newValue
         },
         deep: true,
      },
      value() {
         console.log("value", this.value)
         if (this.value == "" || this.value == 0 || this.value == 0.5) {
            this.$emit('input', "");
            return
         }
         this.$emit('input', Math.floor(this.value));
      },
   },
   methods: {
      keyEnter(event) {
         event.preventDefault();
         event.target.blur()
      },
      inputNum() {
         console.log(this.value);
      },
      //设置长期
      setLongTerm() {
         this.$emit('input', 4102415999000);  //2099年12月31日23:59:59
      },
      clear() {
         this.$refs.dateinput.value = ''
         this.$emit('input', '');
      },
      svalue(value) {
         if (value) {
            return this.dateFormat(value);
         } else {
            return '';
         }
      },
      tran(time) {
         if (time == '' && this.isNull) {
            this.value = ""
            this.$emit('input', '');
            return
         }
         if (time == '长期') {
            this.value = 4102415999000
            this.$emit('input',  4102415999000);
            return
         }
         console.log(time.indexOf('-'));

         let showMessage = false
         if (time.indexOf('-') != -1) {
            let arr = time.split('-')
            console.log(arr)
            for (let i = 0; i < arr.length; i++) {
               if (i > 0 && arr[i] == '') { //2022-
                  showMessage = true
               } else if (arr[i].length == 1) {
                  showMessage = true
               }

            }
         }
         if (showMessage) {
            this.$message("格式错误！正确格式为：20230606或2023-06-06")
            return
         }
         console.log('time', time);
         var timeStr = time.toString()
         var newTime = timeStr.replace(/[^0-9]/ig, "")
         var adate = ''
         var bdate = ''
         console.log(newTime.length);
         if (newTime.length == 8) {
            var year = newTime.substring(0, 4)
            if (Number(year) >= 1970) {
               var month = newTime.substring(4, 6)
               var day = newTime.substring(6, 8)
               console.log(year + '年' + month + '月' + day + '日')
               adate = year + '年' + month + '月' + day + '日'
               bdate = year + '-' + month + '-' + day
            } else {
               adate = ''
               bdate = ''
            }
         } else if (newTime.length == 6) {
            var year = newTime.substring(0, 4)
            if (Number(year) >= 1970) {
               var month = newTime.substring(4, 6)
               adate = year + '年' + month + '月'
               bdate = year + '-' + month + '-01'
            } else {
               adate = ''
               bdate = ''
            }
            this.$emit('input', this.getLong(bdate, 1));
            return adate
         } else if (newTime.length == 4) {
            var year = newTime.substring(0, 4)
            if (Number(year) >= 1970) {
               var a = newTime.substring(0, 2)
               var b = newTime.substring(2, 4)
               if (Number(a) < 12 && Number(a) > 0 && Number(b) > 0 && Number(b) < 31) {
                  var date = new Date;
                  var y = date.getFullYear()
                  adate = y + '年' + a + '月' + b + '日'
                  bdate = y + '-' + a + '-' + b
               } else {
                  if (year >= 1970) {
                     adate = newTime + '年' + '1月' + '1日'
                     bdate = year + '-01' + '-01'
                  } else {
                     adate = ''
                     bdate = ''
                  }
               }
            } else {
               adate = ''
               bdate = ''
            }
         } else {
            adate = ''
            bdate = ''
         }
         this.$emit('input', this.getLong(bdate));
         return adate
      },
      //dateFormat函数 long转date型
      dateFormat(longTypeDate) {
         console.log(longTypeDate,"测试123123");
         
         var dateType = "";
         if (longTypeDate) {
            if (longTypeDate == 4102415999000 && this.isLongTime) return '长期'
            let str = longTypeDate.toString()
            if (str.substring(str.length - 3) == '001') {
               longTypeDate = parseInt(longTypeDate - 1);
               var date = new Date(longTypeDate);
               dateType += date.getFullYear();   //年  
               dateType += "年" + this.getMonth(date); //月   
               dateType += "月"
               // + this.getDay(date);   //日
               // dateType += '日'  
               return dateType;
            }
            longTypeDate = parseInt(longTypeDate);
            var date = new Date(longTypeDate);
            // if (date.getFullYear() >= 2099) {
            //     dateType = '长期'
            // } else {
            dateType += date.getFullYear();   //年  
            dateType += "年" + this.getMonth(date); //月   
            dateType += "月" + this.getDay(date);   //日
            dateType += '日'

            // }

         } else {
            dateType = (new Date()).format("yyyy-MM-dd");
         }
         return dateType;
      },
      //返回 01-12 的月份值   
      getMonth(date) {
         var month = "";
         month = date.getMonth() + 1; //getMonth()得到的月份是0-11  
         if (month < 10) {
            month = "0" + month;
         }
         return month;
      },
      //返回01-30的日期  
      getDay(date) {
         var day = "";
         day = date.getDate();
         if (day < 10) {
            day = "0" + day;
         }
         return day;
      },
      //getLong函数 date转long型
      getLong(date, e) {
         if (date != '') {
            date = Date.parse(date.replace(new RegExp("-", "gm"), "/"));
         }
         console.log(date, "213212123123123123");

         var timeNum = ""
         if (!this.isType) {
            if (date != "" && date > 0) {
               var time = Number(new Date().getTime()) - Number(new Date(new Date().toLocaleDateString()).getTime())
               timeNum = date + time
            } else {
               timeNum = Number(new Date().getTime())
            }
         } else {
            timeNum = date
         }
         if (e == 1) {
            if (this.value == timeNum + 1) {
               this.time = Number(timeNum) + 0.5
               timeNum = Number(timeNum) + 0.5
            }
            return timeNum + 1
         }
         if (this.value == timeNum) {
            this.time = Number(timeNum) + 0.5
            timeNum = Number(timeNum) + 0.5
         }
         if ((String(timeNum) == "NaN" || timeNum == "")&&!this.isError) {
            this.$message.error("日期格式不对")
            return ""
         } else {
            return timeNum;
         }
      }
   },
}
</script>
<style scoped>
input {
   -webkit-appearance: none;
   background-color: #fff;
   background-image: none;
   border-radius: 4px;
   border: 1px solid #dcdfe6;
   box-sizing: border-box;
   color: #606266;
   display: inline-block;
   font-size: 12px;
   /* height: 40px;
    line-height: 40px; */
   outline: 0;
   padding: 0 5px;
   transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
   width: 200px;
   height: 28px;
   line-height: 28px;
}

.dfLongTerm {
   display: inline-block;
   padding: 0 6px 0 3px;
   background-color: #f5f7fa;
   color: #909399;
   height: 26px;
   line-height: 26px;
   border-top-right-radius: 4px;
   border-bottom-right-radius: 4px;
   cursor: pointer;
   margin-left: -34px;
   z-index: 2;
   width: 34px;
}

.icon {
   position: absolute;
   top: 7px;
   right: 4px;

   cursor: pointer;
   /* #434446 */
}

.icon-active {
   color: #434446;
}

.icon-leave {
   color: #dcdfe6;
}

input:-internal-autofill-selected {
   background: #fff !important;
}

.dis {
   background-color: #f5f7fa;
   border-color: #e4e7ed;
   color: #c0c4cc;
   cursor: not-allowed;
}

.nodis {
   background-color: #fff;
   border-color: #dcdfe6;
   color: #606266;
   cursor: auto;
}
</style>
